module.exports = __webpack_public_path__ + "img/minus.e9c5e1b9.svg";